import HorizontalNavigation from './HorizontalNavigation';

export default HorizontalNavigation;
